var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DeviceAppBarPage",
    { attrs: { title: _vm.pageTitle } },
    [
      !_vm.isPageLoading
        ? _c("KPageContainer", { staticClass: "device-container" }, [
            _c(
              "div",
              [
                _c("h1", [_vm._v(_vm._s(_vm.$tr("header")))]),
                _c(
                  "table",
                  { class: _vm.windowIsSmall ? "mobile-table" : "" },
                  [
                    _c("tr", [
                      _c("th", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$tr("url", {
                                count: _vm.deviceInfo.urls.length,
                              })
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "td",
                        { class: _vm.windowIsSmall ? "mobile" : "" },
                        _vm._l(_vm.deviceInfo.urls, function (url, index) {
                          return _c("KExternalLink", {
                            key: index,
                            attrs: {
                              text: url,
                              href: url,
                              primary: true,
                              openInNewTab: true,
                              appearance: "basic-link",
                            },
                          })
                        }),
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("th", [_vm._v(_vm._s(_vm.$tr("freeDisk")))]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.deviceInfo.content_storage_free_space)
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("th", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$tr("kolibriVersion")) +
                            "\n          "
                        ),
                      ]),
                      _c("td", { class: _vm.windowIsSmall ? "mobile" : "" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.deviceInfo.version) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.coreString("deviceNameLabel"))),
                      ]),
                      _c(
                        "td",
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.deviceNameWithId) +
                              "\n            "
                          ),
                          _c("KButton", {
                            staticClass: "edit-button",
                            attrs: {
                              text: _vm.coreString("editAction"),
                              appearance: "basic-link",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showDeviceNameModal = true
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c("h1", [_vm._v(_vm._s(_vm.$tr("advanced")))]),
                _c("p", [_vm._v(_vm._s(_vm.$tr("advancedDescription")))]),
                _c(
                  "div",
                  [
                    _c("KButton", {
                      attrs: { text: _vm.buttonText, appearance: "basic-link" },
                      on: {
                        click: function ($event) {
                          _vm.advancedShown = !_vm.advancedShown
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm.advancedShown
                  ? _c("TechnicalTextBlock", {
                      staticClass: "bottom-section",
                      attrs: { dir: "auto", text: _vm.infoText },
                    })
                  : _vm._e(),
                _vm.showDeviceNameModal
                  ? _c("DeviceNameModal", {
                      attrs: { deviceName: _vm.deviceName },
                      on: {
                        submit: _vm.handleSubmitDeviceName,
                        cancel: function ($event) {
                          _vm.showDeviceNameModal = false
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }